<div [formGroup]="form">
  <div class="flex-row-generic">
    <!-- Clearinghouse -->
    <div class="flex-item-two-columns form-group">
      <label for="{{ baseId }}-clearinghouse">Clearinghouse</label>
      <ap-findcontrol
        id="{{ baseId }}-clearinghouse"
        controlName="ClearinghouseUid"
        findControlDisplayName="Find Clearinghouse"
        [baseId]="baseId"
        [form]="form"
        [apFormGroup]="form"
        [formGroupSubmitted]="isSubmitted"
        [singleSelect]="true"
        [findControlId]="findControlIdService.ListClaimClearingHouse"
        [(selectedPks)]="clearingHousePks"
        (chipsChange)="onClearinghouseDataPopulate($event)"
        (dirty)="clearingHouseUidControl.markAsDirty()"
      >
      </ap-findcontrol>
    </div>
    <!-- Clearinghouse -->

    <!-- Claim Electronic Payer -->
    <div class="flex-item-two-columns form-group">
      <label for="{{ baseId }}-claim-electronic-payer">Claim Electronic Payer</label>
      <ap-findcontrol
        id="{{ baseId }}-claim-electronic-payer"
        controlName="ElectronicPayerUid"
        findControlDisplayName="Find Electronic Payer"
        [baseId]="baseId"
        [form]="form"
        [apFormGroup]="form"
        [formGroupSubmitted]="isSubmitted"
        [required]="isClaimElectronicPayerFindControlRequired"
        [singleSelect]="true"
        [findControlId]="findControlIdService.ViewClearinghouseInactive"
        [additionalSearchParameters]="claimElectronicPayerAdditonalSearchParameters"
        [(selectedPks)]="electronicPayerPks"
        (chipsChange)="onClaimElectronicPayerDataPopulate($event)"
        (dirty)="electronicPayerUidControl.markAsDirty()"
      >
      </ap-findcontrol>
    </div>
    <!-- Claim Electronic Payer-->
  </div>

  <hr />
  <h4
    id="{{ baseId }}-claim-options-subtitle"
    translate
  >Claim Options</h4>

  <div class="flex-row-generic">
    <!-- Electronic Claim Format -->
    <div class="flex-item-two-columns form-group">
      <label for="{{ baseId }}-electronic-claim-format">Electronic Claim Format</label>
      <ap-findcontrol
        id="{{ baseId }}-electronic-claim-format"
        controlName="ElectronicClaimFormatUid"
        findControlDisplayName="Find Claim Format"
        [baseId]="baseId"
        [form]="form"
        [apFormGroup]="form"
        [formGroupSubmitted]="isSubmitted"
        [required]="isElectronicClaimFormatFindControlRequired"
        [singleSelect]="true"
        [findControlId]="FindControlIdService.ListClaimFormat"
        [(selectedPks)]="electronicClaimFormatPks"
        (dirty)="electronicClaimFormatUidControl.markAsDirty()"
      >
      </ap-findcontrol>
    </div>
    <!-- Electronic Claim Format -->

    <!-- Paper Claim Format -->
    <div class="flex-item-two-columns form-group">
      <label for="{{ baseId }}-paper-claim-format">Paper Claim Format</label>
      <ap-findcontrol
        id="{{ baseId }}-paper-claim-format"
        controlName="PaperClaimFormatUid"
        findControlDisplayName="Find Claim Format"
        [baseId]="baseId"
        [form]="form"
        [apFormGroup]="form"
        [formGroupSubmitted]="isSubmitted"
        [singleSelect]="true"
        [findControlId]="FindControlIdService.ListClaimFormat"
        [(selectedPks)]="paperClaimFormatPks"
        (dirty)="paperClaimFormatUidControl.markAsDirty()"
      >
      </ap-findcontrol>
    </div>
    <!-- Paper Claim Format -->
  </div>

  <div class="flex-row-generic">
    <!-- Paper Claim Default Options -->
    <div class="flex-item-two-columns form-group">
      <label for="{{ baseId }}-paper-claim-default-options">Paper Claim Default Options</label>
      <ap-findcontrol
        id="{{ baseId }}-paper-claim-default-options"
        controlName="PaperClaimDefaultOptionUid"
        findControlDisplayName="File"
        [baseId]="baseId"
        [form]="form"
        [apFormGroup]="form"
        [formGroupSubmitted]="isSubmitted"
        [required]="getFindControlValidation('PaperClaimDefaultOptionUid')"
        [singleSelect]="true"
        [findControlId]="findControlIdService.ListMisc"
        [requiredSearchParameters]="requiredSearchParameters"
        [(selectedPks)]="paperClaimDefaultOptionPks"
        (dirty)="paperClaimDefaultOptionUidControl.markAsDirty()"
      >
      </ap-findcontrol>
    </div>
    <!-- Paper Claim Default Options -->
  </div>

  <hr />

  <div class="flex-row-generic">
    <!-- Claim Scrub Profile -->
    <div class="flex-item-two-columns form-group">
      <label for="{{ baseId }}-claim-scrub-profile">Claim Scrub Profile</label>
      <ap-findcontrol
        id="{{ baseId }}-claim-scrub-profile"
        controlName="ScrubProfileUid"
        findControlDisplayName="Find Claim Scrub Profile"
        [baseId]="baseId"
        [form]="form"
        [apFormGroup]="form"
        [formGroupSubmitted]="isSubmitted"
        [required]="getFindControlValidation('ScrubProfileUid')"
        [singleSelect]="true"
        [findControlId]="FindControlIdService.ListScrubProfile"
        [(selectedPks)]="scrubProfilePks"
        (dirty)="scrubProfileUidControl.markAsDirty()"
      >
      </ap-findcontrol>
    </div>
    <!-- Claim Scrub Profile -->
  </div>

  <div class="flex-row-generic mt-4">
    <div class="col-md-12 form-group">
      <label
        for="{{ baseId }}-fee-schedule"
        class="radio-group-label"
      >
        <mat-radio-group
          formControlName="AcceptAssignmentStatus"
          class="radio-group"
        >
          <mat-radio-button
            id="{{ baseId }}-accept-assignment"
            value="Accept Assignment"
            translate
          >Accept
            Assignment</mat-radio-button>
          <mat-radio-button
            id="{{ baseId }}-accept-assignment-lab-only"
            value="Accept Assignment, Lab Only"
            translate
          >Accept Assignment, Lab Only</mat-radio-button>
          <mat-radio-button
            id="{{ baseId }}-do-not-accept-assignment"
            value="Do not Accept Assignment"
            translate
          >Do not
            Accept Assignment</mat-radio-button>
        </mat-radio-group>
      </label>
    </div>
  </div>

  <div class="flex-row-generic">
    <!-- Member ID Format -->
    <div class="flex-item-two-columns form-group">
      <label for="{{ baseId }}-member-id-format">Member ID Format</label>
      <input
        id="{{ baseId }}-member-id-format"
        type="text"
        class="form-control"
        [ngClass]="{ error: showErrors(memberIdFormatControl, isSubmitted), 'required': isRequired(memberIdFormatControl) }"
        [maxlength]="fcListValidation.validations.MemberIDFormat.MaxLength"
        formControlName="MemberIDFormat"
      />
      <div
        *ngIf="showErrors(memberIdFormatControl, isSubmitted)"
        id="{{ baseId }}-warning-text-member-id-format"
        class="incorrect-input"
        translate
      >
        {{
        memberIdFormatControl.errors
        | fcListValidation : 'Member ID Format' : { pattern: 'Only the characters (a, A, 9, -, , ?) are valid' }
        }}
      </div>
    </div>
    <!-- Member ID Format -->

    <!-- Group ID Format -->
    <div class="flex-item-two-columns form-group">
      <label for="{{ baseId }}-group-id-format">Group ID Format</label>
      <input
        id="{{ baseId }}-group-id-format"
        type="text"
        class="form-control"
        [ngClass]="{ error: showErrors(groupIdFormatControl, isSubmitted), 'required': isRequired(groupIdFormatControl) }"
        [maxlength]="fcListValidation.validations.GroupIDFormat.MaxLength"
        formControlName="GroupIDFormat"
      />
      <div
        *ngIf="showErrors(groupIdFormatControl, isSubmitted)"
        id="{{ baseId }}-warning-text-group-id-format"
        class="incorrect-input"
        translate
      >
        {{
        groupIdFormatControl.errors
        | fcListValidation : 'Group ID Format' : { pattern: 'Only the characters (a, A, 9, -, , ?) are valid' }
        }}
      </div>
    </div>
    <!-- Group ID Format-->
  </div>

  <div
    *ngIf="showClaimStatusPayerControl"
    class="flex-row-generic"
  >
    <!-- Claim Status Payer -->
    <div class="flex-item-two-columns form-group">
      <label for="{{ baseId }}-claim-status-payer">Claim Status Payer</label>
      <ap-findcontrol
        id="{{ baseId }}-claim-status-payer"
        controlName="ClaimStatusPayerUid"
        findControlDisplayName="Find Claim Status Payer"
        [baseId]="baseId"
        [form]="form"
        [apFormGroup]="form"
        [formGroupSubmitted]="isSubmitted"
        [singleSelect]="true"
        [findControlId]="FindControlIdService.ListClaimStatusPayer"
        [(selectedPks)]="claimStatusPayerPks"
        (dirty)="claimStatusPayerUidControl.markAsDirty()"
      >
      </ap-findcontrol>
    </div>
    <!-- Claim Status Payer -->
  </div>
</div>
